module.exports = __webpack_public_path__ + "img/bottom-icon3.f45e55b4.png";